module.exports = __webpack_public_path__ + "img/illus_wizard_3.a2a84b03.png";